import React from "react";
import PropTypes from "prop-types";

import { UserForm } from "../../../../components/Users";

const Details = ({ id, editing, inputs, onChange, FromEmployee }) => (
  <React.Fragment>
    <UserForm
      FromEmployee={FromEmployee}
      editing={editing}
      id={id}
      inputs={inputs}
      onChange={onChange}
    />
  </React.Fragment>
);

Details.propTypes = {
  id: PropTypes.number,
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  FromEmployee: PropTypes.bool
};
Details.defaultProps = {
  inputs: {}
};
export default Details;
